<template>
<mobile v-if="gl.isMobile" class="mt-8" />
<desktop v-else />
</template>

<script>
import { useGl } from '@store/ts/gl';

// components
import Desktop from './desktop.vue';
import Mobile from './mobile.vue';

export default {
    name: 'exchange-balances',
    components: {
        Mobile,
        Desktop,
    },
    setup() {
        const gl = useGl();
    
        return {
            gl,
        };
    },
};
</script>